import http from '../httpConfig'
const table = 'mrbase_sys_menus'
// 菜单管理列表
export const get_menuList = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/menu/list-menu/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
// 菜单管理详情
export const get_menuDetail = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/menu/find-menu/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
// 菜单管理新增
export const add_menu = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/menu/add-menu/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
// 菜单管理修改
export const update_menu = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/menu/update-menu/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
// 菜单管理删除
export const del_menu = (params = {}) => {
    params['~table~'] = table
    return new Promise((resolve, reject) => {
        http.post('/api/menu/delete-menu/v1', params)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}